import React from "react";

const TradingHours = () => {
  const data = [
    { day: "Mon - Fri", time: "9am - 5pm" },
    { day: "Saturday", time: "10am - 3pm" },
    { day: "Sunday", time: "Closed" },
    { day: "P. Holiday", time: "Closed" },
  ];
  return (
    <div className="flex flex-col gap-4">
      {data.map((item, idx) => (
        <div key={idx} className="flex gap-3">
          <span className="text-offblack text-sm w-16">{item.day}</span>
          <span className="text-offblack text-sm">{item.time}</span>
        </div>
      ))}
    </div>
  );
};

export default TradingHours;
